import { __assign } from "tslib";
import { SPOILER_TYPE, POLL_TYPE, TIPTAP_POLL_TYPE, } from 'wix-rich-content-common';
export var getAbsoluteUrl = function (url) {
    return url.substring(0, 5).includes('http') ? url : 'http://' + url;
};
export var hasPlugin = function (pluginType, plugins) {
    return !!(plugins === null || plugins === void 0 ? void 0 : plugins.some(function (plugin) { return plugin.type === pluginType; }));
};
export var getPluginConfig = function (pluginType, plugins) { var _a; return ((_a = plugins === null || plugins === void 0 ? void 0 : plugins.find(function (plugin) { return plugin.type === pluginType; })) === null || _a === void 0 ? void 0 : _a.config) || {}; };
export var extractPluginsConfig = function (plugins, helpers) {
    var mergedConfig = {};
    plugins === null || plugins === void 0 ? void 0 : plugins.forEach(function (plugin) {
        var _a;
        var type = plugin.type, config = plugin.config;
        if (Object.keys(config).length !== 0) {
            mergedConfig = __assign(__assign({}, mergedConfig), (_a = {}, _a[type] = config, _a));
        }
        if (type === SPOILER_TYPE && helpers) {
            mergedConfig[type].onViewerAction = helpers.onViewerAction;
        }
    });
    return { config: mergedConfig };
};
export var hasPollsPluginInContent = function (content) {
    if (!content) {
        return false;
    }
    var nodes;
    if (content.entityMap) {
        nodes = Object.values(content.entityMap);
    }
    else {
        nodes = content.nodes;
    }
    return nodes.some(function (node) { return [POLL_TYPE, TIPTAP_POLL_TYPE].includes(node.type); });
};
//# sourceMappingURL=utils.js.map